import axios from "axios";

export default {
  login(username, password) {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
      Authorization: "Basic " + btoa("web_client:admin")
    };

    var data = {
      username: username,
      password: password,
      grant_type: "password",
      client_id: "web_client"
    };

    return axios.post("oauth/token", null, {
      headers: headers,
      params: data
    });
  },
  logOut() {
    window.localStorage.clear();
  },
  isLoggedIn(router) {
    let status = window.localStorage.getItem("authenticated");
    if (status !== "true") {
      router.push("/login");
    }

    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("access_token");
    axios.defaults.headers.common["Content-Type"] =
      "application/x-www-form-urlencoded; charset=utf-8";
  },
  register(user) {
    return axios.post("auth/registration/", user).then(response => {
      return response.data;
    });
  }
};
